import React, { useEffect } from 'react';
import '../../../../shared/src/common/css/scheduler.css';
import SchedulerSteps from '@leadflow/shared/src/feature/scheduler/components/SchedulerStep/SchedulerSteps';
import ThemeProviderWrapper from '../../theme/ThemeContext';
import { SchedulerConfig } from '@leadflow/shared/src/Interface/scheduler/form';
import { schedulerConfigJsonSequence } from '@leadflow/shared/src/common/components/Helper/Helper';
import { FormProvider } from '@leadflow/shared/src/common/contexts/FormContext';
import { SharedStateProvider } from '@leadflow/shared/src/common/contexts/SharedStateContext';
import { useFormConfigContext } from '@leadflow/shared/src/common/contexts/FormConfigContext';

interface HTMLElementWithContent extends HTMLElement {
  textContent: string;
}

const App = () => {
  const { setFormConfig } = useFormConfigContext();
  useEffect(() => {
    const lapInlineFormConfig = document.getElementById(
      'data',
    ) as HTMLElementWithContent | null;
    if (lapInlineFormConfig?.textContent) {
      try {
        const lapJsonData = JSON.parse(
          lapInlineFormConfig.textContent,
        ) as SchedulerConfig;
        if (lapJsonData?.conceptid) {
          const formatData = schedulerConfigJsonSequence(lapJsonData);
          setFormConfig(formatData);
        }
      } catch (error) {
        console.error('Failed to parse JSON:', error);
      }
    } else {
      fetch(`/scheduler-config.json`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((lapData) => {
          if (lapData?.steps) {
            const formatData = schedulerConfigJsonSequence(lapData);
            setFormConfig(formatData);
          }
        })
        .catch((error) => console.error('Error fetching LAP config:', error));
    }
  }, []);

  return (
    <ThemeProviderWrapper>
      <FormProvider>
        <SharedStateProvider>
          <SchedulerSteps />
        </SharedStateProvider>
      </FormProvider>
    </ThemeProviderWrapper>
  );
};

export default App;
